//#region src/properties/stayCardChipTone.ts
var e = "rgba(0, 0, 0, 0.05)", t = "#4B4B52", n = {
	bestPrice: "#006D41",
	instant: "#B45309",
	newArrival: "#AD2F3C",
	options: t
};
//#endregion
export { e as STAY_CARD_CHIP_BG, t as STAY_CARD_CHIP_FG, n as STAY_CARD_CHIP_ICON_TONE };
